var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 27H5V5h13v8h2V4a1 1 0 00-1-1H4a1 1 0 00-1 1v24a1 1 0 001 1h15a1 1 0 001-1v-9h-2v8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M23.798 9.984l-1.414 1.414L25.986 15H10v2h15.986l-3.602 3.602 1.414 1.414L29.814 16z"
  })));
}

export default SvgIconLogout;